<template>
    <div>
        <!-- Contenido anterior con el bloque color vino con el leon y el icono de reproducir video -->
        <div class="d-none contenedor-1 "> <!--d-flex-->
            <div class="contenedor-2">
                <div class="enterate">
                    <h3 style="margin-bottom: .3rem;"><span class="bold900">#ENTÉRATE</span></h3>
                    <div class="lineaBlanca"></div>
                    <div class="mt-1 lineaBlanca2"></div>
                    <h6>
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sequi ut officiis commodi incidunt repellendus autem! Architecto commodi quaerat ut labore possimus unde at quod eius enim? Cupiditate ea magnam beatae!
                    </h6>
                    <a class="btn boton btn-vino" href="#">VER MÁS</a>
                </div>
            </div>
            <div class="play">
                <a href="https://www.facebook.com/shchiapasoficial/videos/366555797977946/" target="_blank">
                    <div class="circulo">
                        <i class="fa fa-play-circle fa-4x" aria-hidden="true"></i>
                    </div>
                </a>
            </div>
        </div>
        <!-- contenido del día naranja -->
        <div class="links_de_interes">
            <div class="container">
                            <div class="contenedor_enterate row">
                <div class="col-md-12 titulo-seccion">
                    <h3><span class="bold">Información</span> destacada</h3>
                </div>
                <div class="col-md-3 link-elemento">
                    <div class="links-container">
                        <div class="titulo-item">
                            <h3>Información de interés</h3>
                        </div>
                        <div class="listado-item">
                            <ul>
                                <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/informacion-interes/calendario-pensiones.pdf">- Calendario de Pensiones</a></li>
                                <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/informacion-interes/constancias-antiguedad.pdf">- Constancias de Antigüedad</a></li>
                                <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/informacion-interes/marcha-funeral.pdf">- Marcha y Funeral</a></li>
                                <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/rendicion-ctas/recursos-mpios/participaciones.asp">- Participaciones a municipios</a></li>
                                <li><a href="https://www.haciendachiapas.gob.mx/informacion-interes/cadenas-productivas/cadenas-productivas.asp" target="_blank">- Programa Cadenas Productivas</a></li>
                                <li><router-link :to="{name: 'MenuArmonizacion'}">- Armonización contable</router-link></li>
                                <!-- <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/informacion-interes/armonizacion-contable/armonizacion-cont.asp">Armonización contable</a></li> -->
                                <!-- <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/informacion-interes/licitaciones/licitaciones.asp">Licitaciones</a></li> -->
                                <li><a target="_blank" href="https://www.haciendachiapas.gob.mx/compras/compras.asp">- Compras Secretaría de Hacienda</a></li>
                            </ul>
                        </div>
                        </div>
                </div>
                <div class="col-md-3 link-elemento">
                    <div class="links-container">
                        <div class="titulo-item">
                            <h3>Organismos públicos</h3>
                        </div>
                        <div class="listado-item">
                            <ul>
                                <li v-for="(item, index) in years" :key="index">
                                    <div @click.prevent="toggleSubmenu(index)" style="cursor:pointer">
                                        <a href="#" class="toggle-submenu">{{item.year}}</a>
                                    </div>
                                        <ul :class="{submenu: true, show: item.isOpen}">
                                            <li v-for="(event, eventIndex) in item.events" :key="eventIndex">
                                                <a :href="event.url" target="_blank" >{{event.name}}</a>
                                            </li>
                                        </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 link-elemento">
                    <div class="links-container">
                                            <div class="titulo-item">
                        <h3>Micrositios</h3>
                    </div>
                    <div class="listado-item">
                        <ul>
                                <li><a href="http://faifap.haciendachiapas.gob.mx/" target="_blank">- Fondo de Ahorro y Préstamos "FAIFAP"</a></li>
                                <li><a href="http://sistemas.haciendachiapas.gob.mx/sigi/Index.aspx?id=1" target="_blank">- SIGI</a></li>
                                <li><a href="http://remates.haciendachiapas.gob.mx/Remates/" target="_blank">- Remates en línea Chiapas</a></li>
                                <li><a href="https://www.haciendachiapas.gob.mx/SitioNuevo/modulo-planeacion" target="_blank">- Manual de Formatos</a></li>
                                <li><a href="https://www.haciendachiapas.gob.mx/SitioNuevo/TramitesHaciendaExternos" target="_blank">- Formatos Oficiales de la Secretaría de Hacienda</a></li>
                                <li><a href="https://www.haciendachiapas.gob.mx/sisvalof/" target="_blank">- Sistema de Validación de Órdenes de Fiscalización</a></li>
                                <li><a href="https://www.ceieg.chiapas.gob.mx/home" target="_blank">- CEIEG</a></li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div class="col-md-3 link-elemento">
                    <div class="links-container">
                        <div class="titulo-item">
                            <h3>Sitios de interés</h3>
                        </div>
                        <div class="listado-item">
                            <ul>
                                <li><a href="https://www.coesmer.chiapas.gob.mx/" target="_blank">- Comisión Estatal de Mejora Reg.</a></li>
                                <li><a href="https://itaipchiapas.org.mx/" target="_blank">- ITAIP Chiapas</a></li>
                                <li><a href="https://siem.economia.gob.mx/" target="_blank">- SIEM</a></li>
                                <li><a href="http://tesoreriaunica.haciendachiapas.gob.mx/tesoreriaunica/wfLogueo.aspx" target="_blank">- SINEDEP</a></li>
                                <li><a href="https://www.chiapas.gob.mx/tram_servicios/uadministrativas.php?id=3178&dependencia=Secretar%C3%ADa%20de%20Hacienda" target="_blank">- Trámites y Servicios de la Secretaria de Hacienda</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>


    </div>
</template>
<script>
export default {
  data() {
    return {
      years: [
        {
          year: 2025,
          isOpen: false,
          events: [
            { name: '- SIGHA Anteproyecto', url: 'https://siahe.haciendachiapas.gob.mx/SIGHA/2025/Anteproyecto/Principal/login' }
          ]
        },
        {
          year: 2024,
          isOpen: false,
          events: [
            { name: '- SI (Anteproyecto)', url: 'https://siahe.haciendachiapas.gob.mx/SI2024/Anteproyecto/Principal/login' },
            { name: '- SEPI', url: 'https://siahe.haciendachiapas.gob.mx/SEPI/Cuenta/Login?ReturnUrl=%2fSEPI' },
            { name: '- SIGHA', url: 'https://siahe.haciendachiapas.gob.mx/SIGHA2024/Presupuesto/Principal/login' },
            { name: '- SIPLAN', url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/SIPLAN24/SIPLAN24.asp' },
            { name: '- Costos de Tesoreria', url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/COSTOS24/COSTOS24.asp' },
            { name: '- Rep. Cierre de Octubre', url: 'https://siahe.haciendachiapas.gob.mx/SIGHA2024/CierreMensual/Principal/login' }
          ]
        },
        {
          year: 2023,
          isOpen: false,
          events: [
            { name: '- SAPE', url: 'https://presupuesto.haciendachiapas.gob.mx/SAPE2023/Armonizacion/Index.aspx' },
            { name: '- SIPLAN', url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/SIPLAN23/SIPLAN23.asp' },
            { name: '- Costos de Tesoreria', url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/COSTOS23/COSTOS23.asp' },
            {name: '- SIAHE-AC', url: 'https://siahe.haciendachiapas.gob.mx/SIAHE2023/Armonizacion/Index.aspx'},
            { name: '- Rep. Cierre de Diciembre', url: 'https://siahe.haciendachiapas.gob.mx/cierremensual2023/Armonizacion/Index.aspx' }
          ]
        },
        {
          year: 2022,
          isOpen: false,
          events: [
            { name: '- SAPE', url: 'https://presupuesto.haciendachiapas.gob.mx/SAPE2022/Armonizacion/Index.aspx' },
            { name: '- Costos de Tesoreria', url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/COSTOS22/COSTOS22.asp' },
            { name: '- SIAHE-AC', url: 'https://siahe.haciendachiapas.gob.mx/SIAHE2022/Armonizacion/Index.aspx' },
            { name: '- SIPLAN', url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/SIPLAN22/SIPLAN22.asp' },
            { name: '- Rep. Cierre de Diciembre', url: 'https://siahe.haciendachiapas.gob.mx/cierremensual2022/Armonizacion/Index.aspx' }
          ]
        }
      ]
    };
  },
  methods: {
    // toggleSubmenu(index) {
    //   this.years[index].isOpen = !this.years[index].isOpen;
    // }
    // toggleSubmenu(index){
    //     this.years.forEach((item, i) => {
    //         item.isOpen = i === index;
    //     })
    // }
    toggleSubmenu(index) {
      // Verifica si el submenú clicado ya está abierto
      const isCurrentlyOpen = this.years[index].isOpen;

      // Cierra todos los submenús
      this.years.forEach((item, i) => {
        item.isOpen = false;
      });

      // Si el submenú clicado estaba cerrado, ábrelo
      if (!isCurrentlyOpen) {
        this.years[index].isOpen = true;
      }
    }
  }
};
</script>
<style scoped>
 /* RESPONSIVE PARA DISPOSITIVOS */
@media (min-width: 336px) and (max-width: 420px) {
  /* Estilos para teléfonos móviles pequeños */
      .links_de_interes .contenedor_enterate .titulo-seccion h3 .bold:before{
        bottom: -40px; /* Ajusta este valor para colocar el pseudo-elemento debajo del texto */
        background-color: #212529; /* Color de fondo del pseudo-elemento */
    }
    .links_de_interes .contenedor_enterate .titulo-seccion h3 .bold:after{
        bottom: -50px; /* Ajusta este valor para colocar el pseudo-elemento debajo del texto */
    }
}
@media (min-width: 421px) and (max-width: 600px) {
  /* Estilos para teléfonos móviles grandes y tabletas pequeñas */
    .links_de_interes .contenedor_enterate .titulo-seccion h3 .bold:before{
        bottom: -16px; /* Ajusta este valor para colocar el pseudo-elemento debajo del texto */
        background-color: #212529; /* Color de fondo del pseudo-elemento */
    }
    .links_de_interes .contenedor_enterate .titulo-seccion h3 .bold:after{
        bottom: -28px; /* Ajusta este valor para colocar el pseudo-elemento debajo del texto */
    }
}
@media (min-width: 601px) and (max-width: 940px) {
  /* Estilos para pantallas de escritorio medianas y grandes */
  .links_de_interes .contenedor_enterate .link-elemento .links-container {
   width: 110%;
  }
}
</style>
